import React, { useState, useEffect } from 'react';
import { BookingType, EmployeeType } from '../../Components/Types';
import styled from "styled-components";
import Banner from '../../Components/Banner';
import MyDetails from './MyDetails';
import MyBookings from './MyBookings';
import { splitArray } from '../../Components/Functions';
import TermsCons from './TermsCons';
import { bookingsPerPage } from '../../Components/Constants';
import { useParams } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import DashboardNav from './DashboardNav';
import ReactGA from "react-ga4";
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { BookingAPI } from 'API/BookingAPI';
import { useMsal } from '@azure/msal-react';

const Content = styled.div`
    padding:1em;
    @media (min-width: 500px) {
        padding:4em;
    }
    @media (min-width: 1050px) {
        padding:4em 8em 4em 8em;
    }
`;
const TopRow = styled.div`
    height: 3em;
    width: 100%;
`;
const AccountName = styled.p`
    float:right;
    font-size:1.5rem;
    font-family: Lato-Bold;
    color: var(--main-teal-color);
`;
function MyAccountPage() {
    const { tab } = useParams<{ tab: 'Details' | 'Bookings' | 'TermsAndConditions' }>();
    const [employee, setEmployee] = useState<EmployeeType>({} as EmployeeType);
    const [bookings, setBookings] = useState<BookingType[][]>([]);
    const { currentEmployee  } = useSelector((state: RootState) => state.auth);

    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    const { instance } = useMsal();
    useEffect(() => {
        if (currentEmployee) {
            const getBookings = async () => {
                setEmployee(currentEmployee);
                const response = await BookingAPI.getAll(instance);
                if (response.length > 0) {
                    const bookings: BookingType[] = response.filter((booking: BookingType) => booking.booking_status_id > 4 && booking.booking_status_id < 99);
                    const splitData = splitArray(bookings, bookingsPerPage);
                    setBookings(splitData);
                }
            }
            getBookings();
        }
        
    }, [currentEmployee]);

    const desktopView = useMediaQuery({
        query: '(min-width: 1050px)'
    });
    return (
        <>
            <Banner mainText="My Account" />
            <Content>
                {desktopView &&
                    <TopRow>
                        <AccountName>Welcome {employee.firstname}</AccountName>
                    </TopRow>
                }
                {!desktopView &&
                    <DashboardNav/>
                }
                <div style={{display: "flex", width: "100%" }}>
                    {desktopView &&
                        <DashboardNav/>
                    }
                    {tab == 'Details' && <MyDetails/> }
                    {tab == 'Bookings' && <MyBookings bookings={bookings} />}
                    {tab == 'TermsAndConditions' && <TermsCons />}
                </div>
            </Content>
        </>
    );
}
export default MyAccountPage;
